
    import I18n from 'i18nObj';
    
      import 'translations/generic_error_page';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('generic_error_page');
  